import Vue from 'vue';
import App from './App.vue';
import core from '@bmp-vue/core';
import hacktimer from 'hacktimer'
import ui from '@/api/ui.js'
import functions from '@/functions/index.js'
import { getFeatureFlag } from '@/plugins/featureFlags'
import { initFeatureFlags } from '@/plugins/featureFlags/datadogProvider'
import VueFileAgent from "vue-file-agent";
import VueFileAgentStyles from "vue-file-agent/dist/vue-file-agent.css";
import '@/views/agendaderecebiveis/negociacaoCampos.css';

Vue.use(VueFileAgent);
Vue.use(VueFileAgentStyles);

Vue.config.productionTip = false;

var controllers = require.context('@/controllers', true, /\.js$/);
const theme = require('@/plugins/vuetify/theme').default;

const parceiros = JSON.parse(localStorage.getItem('parceiros')) || [];
const empresa = JSON.parse(localStorage.getItem('empresa')) || {};

let partner = null;

parceiros.forEach((parceiro) => {
  if (parceiro.value === empresa.codigo) {
    partner = parceiro;
  }
});

(async () => {
await initFeatureFlags(partner)

const agendaRecebiveisHabilitado = getFeatureFlag('retaguarda_receivables_schedule_enabled', false)

const paths = partner !== null
  ? require('@/plugins/router/paths').default(partner.onboardingContaHabilitado, agendaRecebiveisHabilitado)
  : require('@/plugins/router/paths').default(false, agendaRecebiveisHabilitado);

Vue.use(core, {
  controllers,
  paths,
  theme,
  defaultViews: false,
  carregaEnums: false,
  extendRouterBeforeEach: function (vm, to, from, next) {
    const empresa = vm.$store.getters.empresa
    const permite = empresa && empresa.codigo && empresa.codigo !== vm.global.GuidEmpty

    if (to.fullPath === '/authcompany' && permite) {
      return false
    }

    if (vm.$store._actions['default/beforeEach']) {
      vm.$store.dispatch('default/beforeEach', { to, from, next })
    }

    let partner = JSON.parse(localStorage.getItem('parceiros'));
    if (Array.isArray(partner))
      partner = partner.find(x => x.value == empresa.codigo);

    if (to.path && to.path.includes('agendaderecebiveis')) {
      if (!getFeatureFlag('retaguarda_receivables_schedule_enabled', false)) return false
    }

    if (partner) {
      if (to.meta.allParametersRequired) {
        return to.meta.parameters.every(param => partner[param]);
      }
      if (to.meta.parameters) {
        return to.meta.parameters.some(param => partner[param]);
      }
    }

    return permite
  },
  mount: (options) => {
    require('@/components/')

    Vue.prototype.$api.UI = {
      ...Vue.prototype.$api.UI,
      ...ui
    }

    Vue.prototype.$api.Functions = {
      ...Vue.prototype.$api.Functions,
      ...functions
    }

    Vue.use(hacktimer)

        new Vue({
      ...options,
      render: h => h(App)
    }).$mount('#app');
  }
});
})();
